const Forbidden = () => (
  (
    <div>
      <h1>Forbidden</h1>
    </div>
  )
);

export default Forbidden;